module.exports = __webpack_public_path__ + "img/suitcase-rolling.c480fdb6.svg";